<template>
  <!-- SNACKBAR DE CONFIRMAÇÃO GLOBAL -->
  <v-dialog width="300" persistent v-model="getModalConfirmacao.aberto" transition="slide-x-transition">
    <v-card class="card">
      <div class="meio">
        <v-flex xs12>
          <div style="display: flex; justify-content: center; width: 100%">
            <v-avatar class="elevation-1" :color="getModalConfirmacao.cor">
              <v-icon class="fadeIn" color="white"> {{ getModalConfirmacao.icone }} </v-icon>
            </v-avatar>
          </div>
        </v-flex>

        <v-flex class="mt-3 mb-3" xs12>
          <div class="linhaSemQuebra">
            <v-spacer></v-spacer>

            <h4 class="text-center font-weight-light black--text">
              {{ getModalConfirmacao.mensagem }}
            </h4>

            <v-spacer></v-spacer>
          </div>
        </v-flex>

        <v-flex xs12>
          <div class="expande-horizontal semquebra">
            <v-flex class="pa-2" xs6>
              <v-btn color="default" outlined block @click.prevent="desativaModalConfirmacao">
                Não
              </v-btn>
            </v-flex>

            <v-flex class="pa-2" xs6>
              <v-btn color="green" block  @click.prevent="sim()" outlined>
                Sim
              </v-btn>
            </v-flex>
          </div>
        </v-flex>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getModalConfirmacao"]),
  },
  methods: {
    ...mapActions(["desativaModalConfirmacao"]),
    sim() {
      this.$store.dispatch(this.getModalConfirmacao.action, this.getModalConfirmacao.action_value);
      this.desativaModalConfirmacao();
    },
  },
};
</script>

<style>
.card {
  padding: 12px;
  width: 300px;
  overflow: hidden;
  border-radius: 10px;
}
.expande-horizontal {
  display: flex;
  width: 100%;
}
</style>
